// React & Redux
import React, { Fragment } from "react";

// Libs
import { browserHistory } from "react-router";
import Select from "react-select";

// Components
import { ButtonSpocket, InputFormSpocket } from "shared_components";

const SignupLabelTheme = {
  fontSize: "14px",
  fontWeight: "bold",
  letterSpacing: "0.4px",
  color: "#494563"
};

const SignupFormTheme = {
  borderRadius: "4px",
  border: "solid 1px #e7e7e7",
  backgroundColor: "#fafbfc",
  height: "46px"
};

const GetStartedButtonTheme = {
  backgroundColor: "#3bb75d",
  borderRadius: "5px",
  padding: "15px 50px",
  fontSize: "18px",
  color: "#ffffff",
  fontWeight: 600,
  boxShadow: "none"
};

const fields = [
  { label: "Your Name", name: "name", type: "text" },
  { label: "Email", name: "email", type: "email" }
];

const customSelectStyles = {
  container: styles => ({
    ...styles,
    height: 46,
    backgroundColor: "#fafbfc"
  }),
  control: (styles, state) => ({
    ...styles,
    height: 46,
    borderRadius: "4px",
    border: "1px solid #e7e7e7",
    backgroundColor: "#fafbfc",
    boxShadow: state.isFocused ? 0 : 0,
    "&:hover": {
      border: "1px solid #dadde0"
    }
  })
};

const SignUpForm = ({
  isSubmitting,
  errors,
  touched,
  handleChange,
  handleSubmit,
  values,
  status,
  setFieldValue
}) => {

  // If form receives "email already exists" error and query email matches the email inputted, redirect user to login page
  if (status && status.email === "This email already exists.") {
    const query = window.location.search;
    const queryEmail = query.split('email=')[1];
    if (values.email === queryEmail) browserHistory.push(`/login`);
  }

  const renderErrorComponent = fieldName => {
    return (
      <div
        className={`Signup__form-error
            ${
              errors[fieldName] || (status && status[fieldName])
                ? "Signup__form-message-fade-in"
                : ""
            } `}
      >
        {status && status[fieldName]
          ? status[fieldName]
          : touched[fieldName] && errors[fieldName]}
      </div>
    );
  };

  return (
    <form>
      {fields.map((field, index) => {
        return (
          <Fragment key={index}>
            <InputFormSpocket
              label={field.label}
              name={field.name}
              typeInput={field.type}
              value={values[field.name]}
              onChange={handleChange}
              customContainer={SignupLabelTheme}
              customInput={SignupFormTheme}
            />
            {renderErrorComponent(field.name)}
          </Fragment>
        );
      })}

      <label className="Signup__form-top-categories">
        <div className="Signup__form-top-categories-label">
          What products do you want to sell? (Optional)
        </div>

        <Select
          onChange={e => setFieldValue("topCategories", e.value)}
          options={values.listingsCategory.map(category => {
            return {
              value: category.name,
              label: category.name
            };
          })}
          placeholder="Select one category"
          name="topCategories"
          styles={customSelectStyles}
          value={values.topCategories.value}
        />
      </label>

      <ButtonSpocket
        className="Signup__button-submit"
        customButton={GetStartedButtonTheme}
        onClick={handleSubmit}
        disabled={isSubmitting}
        type="button"
        id="Signup__button-submit"
      >
        Get started
      </ButtonSpocket>
    </form>
  );
};

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/signup/SignUpForm.js